import React from 'react';
import Journey from './journeys/Journey/Journey';
import JourneyContext from './journeys/context/JourneyContext'
import * as customer from './journeys/Journey/customer.json';
import { AMSTheme } from './themes';
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import ErrorBoundary from "./ErrorBoundary";
Amplify.configure(awsconfig)

declare var window: any;

function App() {
  return (
    <AMSTheme>
      <JourneyContext>
        <ErrorBoundary >
          <Journey path="" goal={customer.goal} pages={customer.pages} />
        </ErrorBoundary>
      </JourneyContext>
    </AMSTheme>
  )
}

export default App;
